/**
 * Central configuration - sanitizes REACT_APP_BACKEND_URL
 * Handles cases where the env value accidentally includes the key name
 * e.g. "REACT_APP_BACKEND_URL=https://example.com" instead of "https://example.com"
 */
function getBackendUrl() {
  let raw = process.env.REACT_APP_BACKEND_URL || '';

  // If the value contains "=" it might have the key name baked in
  // e.g. "REACT_APP_BACKEND_URL=https://kaidoradza.pl"
  if (raw.includes('=')) {
    const parts = raw.split('=');
    // Find the part that looks like a URL (starts with http)
    const urlPart = parts.find(p => p.startsWith('http'));
    if (urlPart) {
      // Rejoin in case the URL itself contained = (unlikely but safe)
      const idx = raw.indexOf(urlPart);
      raw = raw.substring(idx);
    }
  }

  // Remove trailing slash
  raw = raw.replace(/\/+$/, '');

  // If still empty or invalid, use window.location.origin
  if (!raw || !raw.startsWith('http')) {
    raw = window.location.origin;
  }

  return raw;
}

export const BACKEND_URL = getBackendUrl();
export const API_URL = `${BACKEND_URL}/api`;
